import { animationTransition } from '@shared/utils/animationTransition';
import type { CheckboxV2Props } from '@withjoy/joykit';
import { FILTER_OPTION_LABEL_PROPS } from './components/FilterOptionLabel';

export const CHECKBOX_OVERRIDES: CheckboxV2Props['overrides'] = {
  Label: { props: { ...FILTER_OPTION_LABEL_PROPS } },
  Root: {
    props: {
      borderRadius: '21px',
      display: 'flex',
      width: '100%',
      paddingY: 4,
      paddingRight: 6,
      paddingLeft: 6,
      transition: animationTransition('background-color'),

      _hover: {
        backgroundColor: 'mono2',
      },
      _active: {
        backgroundColor: 'mono3',
      },
    },
  },
};
